<template>

  <body>
    <section id="locations" class="section">
      <div class="container"><img
          src="https://cdn.prod.website-files.com/686b0fce62ce6721b0225627/6875166c9fa43fc5647169d7_logo%20256%20dark%20bg.png"
          loading="lazy" alt="" class="logo medium-logo">
        <div class="heading_h1 blue text-align_left">Leap Perks Program</div>
      </div>
      <div class="container margin-bottom_small">
        <div class="card" v-if="!formSent">
          <div class="form w-form">
            <form class="grid_1-col padding_small gap-xsmall" aria-label="Registration Form">
              <div class="heading_h2 text-align_left">Registration Form</div>

              <div>
                <label for="E-Mail" class="text-align_left">E-Mail</label>
                <input class="input_field w-input" autofocus="true" maxlength="256" name="E-Mail" placeholder="E-Mail"
                  type="email" id="E-Mail" required="" v-model="form.email">
              </div>
              <div>
                <label for="Password" class="text-align_left">Password</label>
                <input class="input_field w-input" autofocus="true" maxlength="256" name="Password"
                  placeholder="Password" type="password" required="" v-model="form.password">
              </div>
              <div>
                <label for="Confirm-Password" class="text-align_left">Confirm Password</label>
                <input class="input_field w-input" autofocus="true" maxlength="256" name="Confirm-Password"
                  placeholder="Confirm Password" type="password" required="" v-model="form.confirmPassword">
              </div>
              <p class="paragraph_medium text-align_left" style="color: salmon;" v-if="showFormError">
                {{ formError }}
              </p>
              <div class="button radius_medium margin-top_small" @click="submitForm">Register</div>

            </form>

          </div>
        </div>
        <div class="card padding_large" v-if="formSent">
          <div class="heading_h3 text-align_center">Thank you, please confirm your email to gain access to the client
            portal.</div>
          <div class="button radius_medium is-secondary" @click="$router.push('/')">Login</div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="w-layout-grid grid_5-col gap-small">
          <div id="w-node-_851d61a1-1dad-400a-5b6a-92b99f998536-b17c3d94"
            class="flex_vertical gap-small w-node-_586ae956-1ff0-8a55-6485-7937ed420a75-ed420a72"><a href="#"
              class="logo w-inline-block">
              <div class="nav_logo-icon"></div>
            </a>
            <ul role="list" aria-label="Social media links" class="footer_icon-group margin_top-auto w-list-unstyled">
              <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                  <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%" viewBox="0 0 16 16">
                      <path
                        d="M16,8.048a8,8,0,1,0-9.25,7.9V10.36H4.719V8.048H6.75V6.285A2.822,2.822,0,0,1,9.771,3.173a12.2,12.2,0,0,1,1.791.156V5.3H10.554a1.155,1.155,0,0,0-1.3,1.25v1.5h2.219l-.355,2.312H9.25v5.591A8,8,0,0,0,16,8.048Z"
                        fill="currentColor"></path>
                    </svg></div>
                  <div class="screen-reader">Follow us on Facebook</div>
                </a></li>
              <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                  <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%" viewBox="0 0 16 16">
                      <path
                        d="M8,1.441c2.136,0,2.389.009,3.233.047a4.419,4.419,0,0,1,1.485.276,2.472,2.472,0,0,1,.92.6,2.472,2.472,0,0,1,.6.92,4.419,4.419,0,0,1,.276,1.485c.038.844.047,1.1.047,3.233s-.009,2.389-.047,3.233a4.419,4.419,0,0,1-.276,1.485,2.644,2.644,0,0,1-1.518,1.518,4.419,4.419,0,0,1-1.485.276c-.844.038-1.1.047-3.233.047s-2.389-.009-3.233-.047a4.419,4.419,0,0,1-1.485-.276,2.472,2.472,0,0,1-.92-.6,2.472,2.472,0,0,1-.6-.92,4.419,4.419,0,0,1-.276-1.485c-.038-.844-.047-1.1-.047-3.233s.009-2.389.047-3.233a4.419,4.419,0,0,1,.276-1.485,2.472,2.472,0,0,1,.6-.92,2.472,2.472,0,0,1,.92-.6,4.419,4.419,0,0,1,1.485-.276c.844-.038,1.1-.047,3.233-.047M8,0C5.827,0,5.555.009,4.7.048A5.868,5.868,0,0,0,2.76.42a3.908,3.908,0,0,0-1.417.923A3.908,3.908,0,0,0,.42,2.76,5.868,5.868,0,0,0,.048,4.7C.009,5.555,0,5.827,0,8s.009,2.445.048,3.3A5.868,5.868,0,0,0,.42,13.24a3.908,3.908,0,0,0,.923,1.417,3.908,3.908,0,0,0,1.417.923,5.868,5.868,0,0,0,1.942.372C5.555,15.991,5.827,16,8,16s2.445-.009,3.3-.048a5.868,5.868,0,0,0,1.942-.372,4.094,4.094,0,0,0,2.34-2.34,5.868,5.868,0,0,0,.372-1.942c.039-.853.048-1.125.048-3.3s-.009-2.445-.048-3.3A5.868,5.868,0,0,0,15.58,2.76a3.908,3.908,0,0,0-.923-1.417A3.908,3.908,0,0,0,13.24.42,5.868,5.868,0,0,0,11.3.048C10.445.009,10.173,0,8,0Z"
                        fill="currentColor"></path>
                      <path
                        d="M8,3.892A4.108,4.108,0,1,0,12.108,8,4.108,4.108,0,0,0,8,3.892Zm0,6.775A2.667,2.667,0,1,1,10.667,8,2.667,2.667,0,0,1,8,10.667Z"
                        fill="currentColor"></path>
                      <circle cx="12.27" cy="3.73" r="0.96" fill="currentColor"></circle>
                    </svg></div>
                  <div class="screen-reader">See us on Instagram<br></div>
                </a></li>
              <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                  <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%" viewBox="0 0 16 16">
                      <path
                        d="M12.3723 1.16992H14.6895L9.6272 6.95576L15.5825 14.829H10.9196L7.26734 10.0539L3.08837 14.829H0.769833L6.18442 8.64037L0.471436 1.16992H5.2528L8.55409 5.53451L12.3723 1.16992ZM11.5591 13.4421H12.843L4.55514 2.48399H3.17733L11.5591 13.4421Z"
                        fill="currentColor"></path>
                    </svg></div>
                  <div class="screen-reader">Connect on X</div>
                </a></li>
              <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                  <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%" viewBox="0 0 16 16">
                      <path
                        d="M15.3,0H0.7C0.3,0,0,0.3,0,0.7v14.7C0,15.7,0.3,16,0.7,16h14.7c0.4,0,0.7-0.3,0.7-0.7V0.7 C16,0.3,15.7,0,15.3,0z M4.7,13.6H2.4V6h2.4V13.6z M3.6,5C2.8,5,2.2,4.3,2.2,3.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C4.9,4.3,4.3,5,3.6,5z M13.6,13.6h-2.4V9.9c0-0.9,0-2-1.2-2c-1.2,0-1.4,1-1.4,2v3.8H6.2V6h2.3v1h0c0.3-0.6,1.1-1.2,2.2-1.2 c2.4,0,2.8,1.6,2.8,3.6V13.6z"
                        fill="currentColor"></path>
                    </svg></div>
                  <div class="screen-reader">Find us on LinkedIn</div>
                </a></li>
              <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                  <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%" viewBox="0 0 16 16">
                      <path
                        d="M15.8,4.8c-0.2-1.3-0.8-2.2-2.2-2.4C11.4,2,8,2,8,2S4.6,2,2.4,2.4C1,2.6,0.3,3.5,0.2,4.8C0,6.1,0,8,0,8 s0,1.9,0.2,3.2c0.2,1.3,0.8,2.2,2.2,2.4C4.6,14,8,14,8,14s3.4,0,5.6-0.4c1.4-0.3,2-1.1,2.2-2.4C16,9.9,16,8,16,8S16,6.1,15.8,4.8z M6,11V5l5,3L6,11z"
                        fill="currentColor"></path>
                    </svg></div>
                  <div class="screen-reader">Watch on YouTube</div>
                </a></li>
            </ul>
          </div>
          <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420abb-ed420a72"
            class="margin-bottom_none w-list-unstyled">
            <li>
              <h2 class="heading_h6 text-color_secondary">Company</h2>
            </li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>Pricing</div>
              </a></li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>Services</div>
              </a></li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>Contact</div>
              </a></li>
          </ul>
          <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420ad3-ed420a72"
            class="margin-bottom_none w-list-unstyled">
            <li>
              <h2 class="heading_h6 text-color_secondary">Support</h2>
            </li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>FAQ</div>
              </a></li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>Terms</div>
              </a></li>
            <li><a href="#" class="footer_link w-inline-block">
                <div>Privacy</div>
              </a></li>
          </ul>
        </div>
        <div class="divider margin-top_xsmall margin-bottom_xsmall"></div>
        <div class="footer_bottom">
          <div class="text-color_secondary">© 2025 Leap Digital Media</div>
        </div>
      </div>
    </footer>

  </body>

</template>

<script>
import { createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "@/firebase";

export default {
  name: 'RegisterView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      formError: "",
      showFormError: false,
      formSent: false,
    };
  },
  components: {
  },
  methods: {
    async submitForm() {
      this.formError = "";
      this.showFormError = false;
      if (!this.form.email || !this.form.password || !this.form.confirmPassword) {
        this.formError = "Please fill in all fields";
        this.showFormError = true;
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.formError = "Passwords don't match";
        this.showFormError = true;
        return;
      }
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, this.form.email, this.form.password);
        console.log("Form submitted:", this.form);
        // save user display name in auth
        await sendEmailVerification(userCredential.user);
        this.formSent = true;
        this.formError = "";
        // update user profile with name in firestore
        // create a user document in firestore
        const userDoc = {
          uid: userCredential.user.uid,
          email: userCredential.user.email,
          displayName: userCredential.user.displayName || "",
          phoneNumber: userCredential.user.phoneNumber || "",
          enrolled: false,
        };

        try {
          await setDoc(doc(db, "users", userCredential.user.uid), userDoc);
          console.log("User document created successfully");
        } catch (err) {
          console.log("Error creating user document:", JSON.stringify(err, null, 2));
        }
        // reset the form after submission
        this.form = {
          name: '',
          email: '',
          password: '',
          confirmPassword: '',
        };
      } catch (error) {
        console.error("Error registering:", error);
        this.form = {
          name: '',
          phone: '',
          email: '',
          password: '',
          confirmPassword: ''
        };
      }
    }
  }
}
</script>
